import { StatusBar } from 'expo-status-bar';
import React, {useState} from 'react';
import { StyleSheet, Text, View, Image, Modal } from 'react-native';
import WebView from 'react-native-web-webview';
import {Button, ImageBackground, TouchableOpacity} from 'react-native-web'

const PolicyHTML = require('./assets/privacy-policy.html');

export default function App() {

  const [isPrivacyEnabled, enablePrivacy] = useState(false);

  return (
    <View style={styles.container}>
      
      <Modal visible={isPrivacyEnabled}>
        <View style={styles.modal}>
            <View style={styles.modalContainer}>
              <WebView
                style={{ flex : 1}}
                originWhitelist={['*']}
                source={{html: PolicyHTML}}
              />
              <Button onPress={() => enablePrivacy(false)} title="Agree"/>
            </View>
        </View>
      </Modal>
      
      <View style={styles.middleContainer}>
        <Image
          style={styles.logoImage}
          source={require('./assets/logo.png')}
          resizeMode='contain'
        />
        <Text style={styles.descriptionText}>Website under development</Text>

      </View>

      <ImageBackground 
          style={styles.headerImage}
          source={require('./assets/pattern.png')}
          resizeMode='cover'
        />

      <View style={styles.bottomContainer}>
          <TouchableOpacity onPress={() => enablePrivacy(true)}>
            <Text style={styles.privacyText}>Privacy Policy & Terms</Text>
          </TouchableOpacity>
          <Text style={styles.privacyText}>   |   </Text>
          <Text style={styles.privacyText}>Contact Us!</Text>
      </View>
    
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#202844'
  },
  middleContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  modal : {
    flex : 1,
    justifyContent : 'center',
    alignItems : 'center',
    backgroundColor: 'rgba(0,0,0,0.8)'
  },
  modalContainer : {
      backgroundColor : 'white',
      width : '80%',
      height : '80%',
  },
  headerImage: {
    width: '100%',
    height: '100%',
    opacity: .2,
    position: 'absolute'
  },
  logoImage:{
    width: '80%',
    height: 150,
    margin: 25
  },
  descriptionText: {
    fontSize: 28,
    color: 'white',
    fontWeight: 'bold'
  }, 
  privacyText: {
    fontSize: 14,
    color: 'white',
  },
  bottomContainer: {
    flexDirection: "row",
    height: 40,
    left: 0,
    marginBottom: "auto",
    alignSelf: 'center'
  }
});
